module.exports = __webpack_public_path__ + "static/turquia-028.thumb-f663948ddc5ad60422ef8408dadd18f0.jpg";